
import {Error, ValidationResult, Validator} from '@/type/validation/result';

import {必須入力, 日付書式} from '@/type/validation/validator';
import {ハンディ移動検索依頼型} from '@/type/movement/records/handy/ハンディ移動取込';

export default class ハンディ移動検索条件チェッカー {
  単項目チェック結果: Error[];

  constructor(target: ハンディ移動検索依頼型) {
    const 単項目チェック = new ValidationResult(単項目チェックvalidators);
    単項目チェック.validate(target);
    this.単項目チェック結果 = 単項目チェック.getErrors;
  }

  hasError(name: string): boolean {
    return this.単項目チェック結果.some((error) => (error.name === name && error.index === 0));
  }

  hasErrors(): boolean {
    return this.単項目チェック結果.length > 0;
  }

  errorMessages(): string[] {
    return this.単項目チェック結果.map((value) => `${value.message}`);
  }
}

const 検索移動年月日Validator = {
  name: '検索移動年月日',
  constraints: [
    {method: 必須入力, message: '移動年月日を入力してください'},
    {method: 日付書式, message: '移動年月日の書式が不正です'},
  ],
};

const 単項目チェックvalidators: Validator[] = [
  検索移動年月日Validator,
];

